import React from 'react';
import ReactDOM from 'react-dom';
import {HelmetProvider} from 'react-helmet-async';
import {PersistGate} from 'redux-persist/lib/integration/react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {configStore} from './store'
import {Provider} from 'react-redux'


const {store, persistor} = configStore();


    //disable console output on production
    //console.log = () => {}
    //console.error = () => {}
    //console.debug = () => {}
    //console.warn = () => {}

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <HelmetProvider>
                <App/>
            </HelmetProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
